import React from 'react';
import FeaturedBannerSection from '../components/FeaturedBannerSection';

import {
	useTranslation,
	useAllCustomCategories,
	useAllCollections,
	// styled,
	useRecommendedApiContents,
	useCurrentUser,
	CategoriesRow,
	SectionHeader,
	Contents,
	SectionWrapper,
	ImageHeader,
	ContentWrapper
} from '@eduvision/toolkit';


const LoggedInUserView = (): JSX.Element | null => {
	const currentUser = useCurrentUser();
	const { t } = useTranslation();
	const progressedContents = React.useMemo(
		() =>
			currentUser?.progressedContents
				.filter((c) => (!c.demo && c.completion !== 1))
				.sort((a, b) => (a.lastProgressedAt! > b.lastProgressedAt! ? -1 : 1)),
		[currentUser?.progressedContents]
	);
	
	const customCategories = useAllCustomCategories();
	const { data: collectionCategories } = useAllCollections();
	const sectionCategories = [...(collectionCategories ? collectionCategories : []), ...(customCategories ? customCategories : [])];


	const recommendedContents = useRecommendedApiContents(currentUser?.audience?.id);
	// const availableCollections = useAvailableCollections(recommendedContents);
	const accessibleProductContents = currentUser?.accessibleProductContents;
	return !currentUser ? (
		<ContentWrapper>{null}</ContentWrapper>
	) : (
		<ContentWrapper>
			<ImageHeader
				src={''}
				title={t('LoggedInUserView.header.title', {
					name: currentUser?.userName || currentUser?.firstName || '',
				})}
				description={t('LoggedInUserView.header.description')}
			/>
			{progressedContents?.length ? (
				<SectionWrapper flexDirection="column">
					<Contents
						filterAfterCategoryGroup="EDUCATION_FORMAT"
						title={t('LoggedInUserView.activeContents.title')}
						subTitle={t('LoggedInUserView.activeContents.subTitle')}
						buttonLabel={t('LoggedInUserView.activeContents.button')}
						navigateTo="/contents"
						contents={progressedContents}
						showProgress
					/>
				</SectionWrapper>
			) : null}
			{accessibleProductContents?.length ? (
				<SectionWrapper flexDirection="column">
					<Contents
						title={t('LoggedInUserView.accessibleContents.title')}
						subTitle={t('LoggedInUserView.accessibleContents.subTitle')}
						contents={accessibleProductContents}
						showProgress
					/>
				</SectionWrapper>
			) : null}

			<SectionWrapper flexDirection="column">
				<Contents
					contents={recommendedContents}
					buttonLabel={t('LoggedInUserView.recommendedContents.button')}
					navigateTo="/contents"
					title={t('LoggedInUserView.recommendedContents.title')}
					subTitle={t('LoggedInUserView.recommendedContents.subTitle')}
					maxItems={6}
				/>
			</SectionWrapper>
			<SectionWrapper padding="2rem" altBackground flexDirection="column">
				<SectionHeader
					alignItems="flex-start"
					title={t('LoggedInUserView.availableCollections.title')}
					subTitle={t('LoggedInUserView.availableCollections.subTitle')}
				/>
				<CategoriesRow data={sectionCategories || undefined} />
			</SectionWrapper>
			<FeaturedBannerSection />
		</ContentWrapper>
	);
};

export default LoggedInUserView;
